import React, { useEffect, useState } from 'react';
import { useOwnerDetails } from 'api/owners';
import { useAuth } from 'contexts/auth/auth';
import { StripePaymentPlan, getPaymentPlans, getSubscriptionManagementLink } from 'api/stripe';
import { Spinner } from 'ui-kit';
import PlanCard from './PlanCard';
import { PaymentPlan } from 'api/types/owner';
import { message } from 'antd';
import { Role } from 'api/types/auth';

import BasicLogo from './images/basic_logo.png';

export const basicPlan: StripePaymentPlan = {
  displayName: 'Basic',
  lookupKey: PaymentPlan.Basic,
  planType: PaymentPlan.Basic,
  price: 0,
  currency: 'usd',
  image: BasicLogo,
};

type Props = {
  interval: 'month' | 'year';
};

export default function Plans({ interval }: Props) {
  const { id: ownerId, role } = useAuth();
  const { data, isLoading } = useOwnerDetails(ownerId);
  const { planLookupKey, plan: ownerPlan, planOverride: ownerPlanOverride } = data;
  const [subscriptionPlans, setSubscriptionPlans] = useState<StripePaymentPlan[]>([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(true);

  useEffect(() => {
    getPaymentPlans().then((res) => {
      if (res.ok) {
        setSubscriptionPlans(res.data);
      } else {
        // eslint-disable-next-line no-console
        console.log(res.errors);
      }
      setIsLoadingPlans(false);
    });
  }, []);
  const getPlans = (interval) => {
    const paidPlans = subscriptionPlans.filter((plan) => plan.interval === interval);
    const allPlans = [basicPlan, ...paidPlans];
    return allPlans.sort((a, b) => a.price - b.price);
  };

  const handleManageSubscription = () => {
    getSubscriptionManagementLink().then((res) => {
      if (res.ok) {
        window.location.href = res.data.url;
      } else {
        message.error('Something went wrong! Try again later.');
      }
    });
  };

  const currentPlanLookupKey = planLookupKey || PaymentPlan.Basic;
  const isPlanSelected = (plan: StripePaymentPlan) =>
    role === Role.HOST && plan.lookupKey === currentPlanLookupKey;
  const getButtonText = (plan: StripePaymentPlan) => {
    if (plan.lookupKey === PaymentPlan.Basic) {
      return 'Get Started';
    } else if (isPlanSelected(plan)) {
      return 'Manage';
    }
    return 'Subscribe';
  };
  return (
    <div className="PlansBody">
      {isLoading || isLoadingPlans ? (
        <Spinner />
      ) : (
        getPlans(interval).map((plan) => (
          <PlanCard
            key={plan.lookupKey}
            image={plan.image}
            interval={interval}
            planName={plan.displayName}
            planType={plan.planType}
            price={plan.price}
            priceId={plan.priceId}
            selected={isPlanSelected(plan)}
            onManage={() => handleManageSubscription()}
            buttonText={getButtonText(plan)}
            ownerPlan={ownerPlan}
            ownerPlanOverride={ownerPlanOverride}
          />
        ))
      )}
    </div>
  );
}
